export enum NotificationTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error'
}

export type NotificationItemType = {
  key: string
  counter: number
  type: NotificationTypeEnum
  text: string
}
